import * as React from 'react';
// import  request  from '@/server/request';
// import config from '@/server/config';
import './index.scss'
import Dialog from '../dialog/index'

interface initProps {
	visiblity ?: boolean,
	titleText ?: string,
	promptText ?: string,
	confirmFn ?: any,
	onOpenFn?(): void,
}

class Tips extends React.Component <initProps, any> {
	constructor(props: any) {
		super(props);
		this.state= {

		};
	}

	render() {
		return (
			<div>
				<Dialog visiblity={this.props.visiblity} >
					<div className="tips">
						{ this.props.visiblity ? this.hideBody() : '' }
						{
							this.props.titleText ? <p className="title" dangerouslySetInnerHTML={{__html: this.props.titleText }}></p> :''
						}

						{
							this.props.promptText ? <p className="prompt" dangerouslySetInnerHTML={{__html: this.props.promptText }}></p> : ' '
						}
						
						<button className="tips-btn" onClick={() => { this.autoBody(); this.props.confirmFn ? this.props.confirmFn() : ''  } }>好</button>
					</div>
				</Dialog>
			</div>
			
		)
	}

	private hideBody() {
		const body = (document as any).body;
		body.style.overflow = 'hidden';
	}

	private autoBody(){
		const body = (document as any).body;
		body.style.overflow = 'auto';
	}
}



export default Tips